import { ApiService, type ApiRequestConfig } from "./api.service";
import type { IFavorite, TFavoriteCreatePayload, TFavoriteUpdatePayload } from "@/types/favorite";

export class FavoriteService extends ApiService {
  async fetchFavorites(slug: string, config?: ApiRequestConfig): Promise<IFavorite[]> {
    return this.get(`/api/workspaces/${slug}/user-favorites/`, config);
  }

  async addFavorite(slug: string, data: TFavoriteCreatePayload): Promise<IFavorite> {
    return this.post(`/api/workspaces/${slug}/user-favorites/`, data);
  }

  async updateFavorite(
    slug: string,
    favoriteId: string,
    data: TFavoriteUpdatePayload,
  ): Promise<IFavorite> {
    return this.patch(`/api/workspaces/${slug}/user-favorites/${favoriteId}/`, data);
  }

  async deleteFavorite(slug: string, favoriteId: string): Promise<void> {
    return this.delete(`/api/workspaces/${slug}/user-favorites/${favoriteId}/`);
  }

  async addProjectFavorite(slug: string, data: { project: string }): Promise<void> {
    return this.post(`/api/workspaces/${slug}/user-favorite-projects/`, data);
  }

  async removeProjectFavorite(slug: string, projectId: string): Promise<void> {
    return this.delete(`/api/workspaces/${slug}/user-favorite-projects/${projectId}/`);
  }

  async fetchProjectFavorites(slug: string): Promise<IFavorite[]> {
    return this.get(`/api/workspaces/${slug}/user-favorite-projects/`);
  }
}
